// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';
import {getClaimRoutes} from '../../../shared/components/create-claim-modal/get-claim-routes-service';
import {routerActions} from 'react-router-redux';

export const updateCreateClaimModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.UPDATE_CLAIM_PIP_CREATE_CLAIM_MODAL_VISIBILITY
        });

    };

export const updateClaimModalMode = mode =>

    dispatch => {

        dispatch({
            mode,
            type: actions.UPDATE_CLAIM_PIP_MODAL_MODE
        });

    };

export const onCreateClaim = (key, pin, claimType) =>

    dispatch => {

        if (key === claimType) {

            dispatch({
                type: actions.RESET_CLAIM_PIP
            });

        }

        document.body.classList.remove('warranty-modal-is-open');
        dispatch(routerActions.push(getClaimRoutes(key, pin)));

    };



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/create-claim-modal-visibility.js